export interface IMediaElementAudioSourceOptions {
    mediaElement: HTMLMediaElement;
}
